<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="store-item" @click="select">
                            <div class="wrap center">
                                {{$store.state.record['orderExp_2'].storeExpIn.storeExp.store.name}}
                            </div>
                            <div class="wrap">
                                <div class="tit">
                                <span class="zh">
                                    外箱条码
                                </span>
                                    <span class="en">
                                    OUTER BOX BARCODE
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="code-top">
                                        {{$store.state.record['orderExp_2'].storeExpIn.barcode}}
                                    </div>
                                    <img src="./../../assets/image/sweep/code.png" alt="">
                                    <div class="code-top">
                                        {{$store.state.record['orderExp_2'].storeExpIn.barcode}}
                                    </div>
                                </div>
                            </div>
                            <div class="wrap">
                                <div class="tit">
                                <span class="zh">
                                    单品条码
                                </span>
                                    <span class="en">
                                    SINGLE PRODUCT BARCODE
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="code-top">
                                        {{$store.state.record['orderExp_2'].storeExpIn.product.barcode}}
                                    </div>
                                    <img src="./../../assets/image/sweep/code.png" alt="">
                                    <div class="code-top">
                                        {{$store.state.record['orderExp_2'].storeExpIn.product.barcode}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="In"  @click="$router.push('/overseas-warehouses/handleOrdersTwoDeliver')">
                    下一步
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    export default {
        name: "investigate",
        data() {
            return {
                list: [
                    'ASpace.png',
                    'BSpace.png'
                ],
                count: '',
                In:false
            }
        },
        methods: {
            select() {
                this.axios.post('/student/store/exp/in/sure', {
                    storeExp: {id: this.$store.state.record['orderExp_2'].storeExpIn.storeExp.id},
                    experiment: {id: this.$store.state.record.experiment.id},
                    barcode: this.$store.state.record['orderExp_2'].storeExpIn.barcode
                }).then(res => {
                    if(res.succeed){
                        this.$swal({
                            text:`${this.$store.state.record['orderExp_2'].storeExpIn.storeExp.store.name}扫码成功`,
                            icon:'success',
                        })
                        this.In = true
                    }else {
                        this.$swal({
                            text:res.message,
                            icon:'warning',
                        })
                    }
                })
            }
        }

    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;
                min-width: 364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                .main-area-box {
                    display: flex;
                    justify-content: center;
                    padding-bottom: 60px;

                    .store-item {
                        display: flex;
                        margin-bottom: 6px;
                        background-color: #FFFFFF;
                        border: 1px solid #adadad;

                        &:hover {
                            cursor: url("../../assets/image/sweep/laba.png"), auto;
                            box-shadow: 0 0 10px #adadad;
                            transition: box-shadow 0.3s ease-in-out;
                        }

                        .wrap {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            padding: 10px 20px;

                            &.center {
                                justify-content: center;
                                font-size: 20px;
                                font-weight: bolder;
                                color: #FFFFFF;
                                background: #5180fc;
                            }

                            div.tit {
                                margin-bottom: 10px;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;

                                span.zh {
                                    font-size: 22px;
                                    font-weight: bolder;
                                }

                                span.en {
                                    font-size: 12px;
                                }
                            }

                            div.cont {
                                &:hover {

                                }

                                .code-top {
                                    font-size: 22px;
                                    font-weight: bolder;
                                }

                                img {
                                    margin: 20px 0 6px 0;
                                }
                            }
                        }
                    }

                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
